export const SENSITIVE_FIELD_SHIELD_MESSAGE = 'Permission required to view this sensitive field.';

export const SENSITIVE_HOST_HIDDEN_MESSAGE = 'Host name is hidden. Click the visibility icon to show.';
